module.exports = __webpack_public_path__ + "static/img/012.9ce8d80.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/factory/012.jpg
// module id = rhc8
// module chunks = 1